<div class="input-group " *ngIf="!disabled">
   <div class="btn-group shadow-small border-round">
      <a class=" btn btn-white  btn-sm truncate-text pl-0 pr-3 pb-0" style="width: 150px;" [ngbPopover]="themeSelector"
         [placement]="'bottom-right'" popoverClass="themeSelector" [autoClose]="'outside'" [container]="'body'"
         #popover="ngbPopover">
         <ng-container *ngIf="selectedColors && selectedColors.length > 0">
            <ng-container *ngFor="let color of selectedColors">
               <div style="width: 10px; height: 20px; display: inline-block;margin-right: 1px;"
                  [ngStyle]="{'background-color': color}"></div>
            </ng-container>
         </ng-container>
         <i class="mio button-icon">color_lens</i>
      </a>
   </div>
</div>

<div class="input-group " *ngIf="disabled">
   <div class=" btn-group shadow-small border-round">
      <a class=" btn btn-white  btn-sm truncate-text pl-0 pr-3 pb-0 disabled" style="width: 150px;">
         <ng-container *ngIf="selectedColors && selectedColors.length > 0">
            <ng-container *ngFor="let color of selectedColors">
               <div style="width: 10px; height: 20px; display: inline-block;margin-right: 1px;"
                  [ngStyle]="{'background-color': color}"></div>
            </ng-container>
         </ng-container>
         <i class="mio button-icon">color_lens</i>
      </a>
   </div>
</div>
<ng-template #themeSelector>
   <h6>Select a theme</h6>
   <ul class="list-group justify-content-between">
      <ng-container *ngFor="let theme of themes">
         <a class="list-group-item d-flex justify-content-between align-items-center"
            (click)="inputTheme = theme; selectTheme(theme);" [ngClass]="{'active':inputTheme.color == theme.color}">
            <div style="width: 25px; height: 20px; display: block;" [ngStyle]="{'background-color': theme.color}"></div>
            <div>
               <ng-container *ngFor="let defaultColor of defaultColors[theme.color]">
                  <div style="width: 25px; height: 20px; display: inline-block;"
                     [ngStyle]="{'background-color': defaultColor}" class="mr-1"></div>
               </ng-container>
            </div>
         </a>
      </ng-container>
   </ul>
   <hr />
   <h6>Select a color</h6>
   <ul class="list-group justify-content-between">
      <li class="list-group-item d-flex justify-content-between align-items-center"
         (click)="inputTheme = tmpTheme; selectTheme(tmpTheme);"
         [ngClass]="{'active':inputTheme.color == tmpTheme.color}">
         <button class="btn btn-sm btn-light px-1 py-1 shadow-small" popoverClass="colorPicker"
            [ngbPopover]="colorPicker" [placement]="'top-start'" [autoClose]="false"
            #colorPickerPopover="ngbPopover">
            <div style="width: 25px; height: 20px; display: block;" [ngStyle]="{'background-color':tmpTheme.color}">
            </div>
         </button>
         <div *ngIf="tmpColors && tmpColors.length > 0">
            <ng-container *ngFor="let color of tmpColors">
               <div style="width: 25px; height: 20px; display: inline-block;" [ngStyle]="{'background-color': color}"
                  class="mr-2"></div>
            </ng-container>
         </div>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
         <div></div>
         <div class="btn-group btn-group-toggle shadow-small float-right" ngbRadioGroup name="themeVisualization"
            (change)="handleChangeComplete()" [(ngModel)]="tmpTheme.visualization">
            <label ngbButtonLabel class="btn-light btn-sm">
               <input ngbButton type="radio" (click)="tmpTheme.visualization = themeVisualizations.SEQUENTIAL"
                  [value]="themeVisualizations.SEQUENTIAL"> Sequential colors
            </label>
            <label ngbButtonLabel class="btn-light btn-sm">
               <input ngbButton type="radio" (click)="tmpTheme.visualization = themeVisualizations.DIVERGENT;"
                  [value]="themeVisualizations.DIVERGENT"> Divergente colors
            </label>
         </div>
      </li>
   </ul>
</ng-template>


<ng-template #colorPicker style="z-index: 9999 !important">
   <color-sketch
      [presetColors]="['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB']"
      [disableAlpha]="'true'" (onChange)="handleChangeComplete($event)">
   </color-sketch>

</ng-template>